import { useEffect } from 'react';

function Alignment() {
    useEffect(() => {
        const modal = document.querySelector('.modal__content');
        const target = document.querySelector('.ImitationIndicator');
        let observer;
        if (target) {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
            };

            const callback = entries => {
                entries.forEach(entry => {
                    const { bottom, height } = entry.boundingClientRect;
                    const margin = Math.max(bottom, 0) - height;
                    modal.style.marginTop = `${margin}px`;
                    modal.classList.remove('hidden');
                });
            };

            observer = new IntersectionObserver(callback, options);
            observer.observe(target);
        } else {
            modal.classList.remove('hidden');
        }

        return () => {
            if (target && observer) {
                observer.unobserve(target);
            }
        };
    });
    return null;
}

export default Alignment;
